// extracted by mini-css-extract-plugin
export default {"mainmenu":"styles_mainmenu__Wyl2f","navmenu":"styles_navmenu__LELJx","navmenu2":"styles_navmenu2__7kzZW"};